import { apiClient } from './client';
import type { SuppliersResponse } from '@/types';

export const suppliersAPI = {
  getAll: () => 
    apiClient.get<SuppliersResponse>('/suppliers'),
};